import type { EnvironmentId } from "@cmmd-forge/contracts";
import type { ReactNode } from "react";

import {
  shouldUseLocalThreadSurface,
  type RemoteRuntimeThreadRouteTarget,
} from "./remoteRuntimeThreadRoute.logic";
import type { RemoteRuntimeConnectionState } from "./remoteRuntimeThreadConnection.logic";
import { RemoteRuntimeThreadRoute } from "./RemoteRuntimeThreadRoute";
import type {
  RemoteThreadDispatchSettings,
  RemoteThreadEnvironmentWaitingReason,
} from "./useRemoteThreadExecutionIntent";

interface RemoteRuntimeThreadSurfaceProps {
  readonly connectionState: RemoteRuntimeConnectionState;
  readonly environmentId: EnvironmentId;
  readonly environmentWaitingReason: RemoteThreadEnvironmentWaitingReason | null;
  readonly localSurface: ReactNode;
  readonly onExecutionIntent: (settings?: RemoteThreadDispatchSettings) => void;
  readonly remoteTarget: RemoteRuntimeThreadRouteTarget | null;
  readonly threadId: string;
}

export function RemoteRuntimeThreadSurface(props: RemoteRuntimeThreadSurfaceProps) {
  const { remoteTarget } = props;
  if (remoteTarget === null || shouldUseLocalThreadSurface(remoteTarget, props.connectionState)) {
    return props.localSurface;
  }
  return (
    <RemoteRuntimeThreadRoute
      environmentId={props.environmentId}
      runtimeId={remoteTarget.runtimeId}
      threadId={props.threadId}
      fallbackTitle={remoteTarget.threadTitle}
      fallbackRuntimeName={remoteTarget.runtimeDisplayName}
      connectionState={props.connectionState}
      environmentWaitingReason={props.environmentWaitingReason}
      historyOnly={remoteTarget.historyOnly}
      onExecutionIntent={props.onExecutionIntent}
      onRetryConnection={props.onExecutionIntent}
    />
  );
}
